<template>
	<nav id="dynvibeNav" class="navbar navbar-light">
		<div class="container-fluid admin" style="align-items: center; min-height: 80px" v-bind:class="{ admin: middle }">
			<div class="navbar-header">
				<button type="button" id="sidebarCollapse" @click="collapseSidebar()" class="btn btn-info navbar-btn">
					<i class="icon-menu"></i>
				</button>
			</div>
			<div v-if="displayDates">
				<datepicker
					ref="datepickerclassic"
					:showdates="true"
					:datefrom="dateFrom"
					:dateto="dateTo"
					:updateParameters="updateParameters"
					:displayAllButton="displayAllButton"
					type="classic"
					@datepickercreated="$emit('datepickercreated')"
					@changedate="$emit('changedate', $event)"
				></datepicker>
			</div>
			<ul class="nav navbar-nav dynvibeNavSearch" v-if="displayFilters">
				<li>
					<div class="popovers popover--active">
						<button
							id="dynvibeFiltersButton"
							class="btn btn-secondary popover__trigger"
							type="button"
							v-bind:class="{ activeFilters: activeFilters }"
							@click="showFilters = !showFilters"
						>
							<i class="icon-zoom"></i>
						</button>
						<div v-show="showFilters" id="dynvibeFilters" class="popover__menu">
							<div class="filters">
								<div class="filterGroup gender">
									<span class="filterTitle">Gender</span>
									<ul style="list-style: none; padding-left: 0px">
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="male"
													v-model="genders"
													v-bind:class="{
														active: genders.includes('male'),
													}"
												/>
												<label for="male">Male</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="female"
													v-model="genders"
													v-bind:class="{
														active: genders.includes('female'),
													}"
												/>
												<label for="female">Female</label>
											</div>
										</li>
									</ul>
								</div>
								<div class="filterGroup age">
									<span class="filterTitle">Age Groups</span>
									<ul style="list-style: none; padding-left: 0">
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="15"
													v-model="ages"
													v-bind:class="{
														active: ages.includes('15'),
													}"
												/>
												<label for="15">-20 y.o</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="25"
													v-model="ages"
													v-bind:class="{
														active: ages.includes('25'),
													}"
												/>
												<label for="25">20/30 y.o</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="35"
													v-model="ages"
													v-bind:class="{
														active: ages.includes('35'),
													}"
												/>
												<label for="35">30/40 y.o</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="45"
													v-model="ages"
													v-bind:class="{
														active: ages.includes('45'),
													}"
												/>
												<label for="45">40/50 y.o</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="55"
													v-model="ages"
													v-bind:class="{
														active: ages.includes('55'),
													}"
												/>
												<label for="55">50/60 y.o</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="65"
													v-model="ages"
													v-bind:class="{
														active: ages.includes('65'),
													}"
												/>
												<label for="65">+60 y.o</label>
											</div>
										</li>
									</ul>
								</div>
								<div class="location">
									<span class="filterTitle">Location</span>
									<div class="col-lg-10" style="padding: 0; margin-top: 6px">
										<select
											id="fli"
											class="dynvibeSelect loadCheckboxOnChange"
											name="country"
											data-type="country"
											style="height: 20px; max-width: 100%; font-size: 13px; font-weight: 400"
											v-model="selectedCountry"
										>
											<option value>Choose country</option>
											<option v-for="country in countrieslist" v-bind:key="country.id" :value="country">
												{{ country.value }}
											</option>
										</select>
									</div>
									<div class="col-lg-2" style="padding: 0; margin-top: 6px">
										<span
											class="dynvibeButtonAdd dynvibeFiltersButtonAddCountry icon-plus"
											@click="addCountry()"
										></span>
									</div>
									<div class="col-lg-12" style="padding: 0px; margin-top: 5px">
										<div class="dynvibeFiltersListCountries">
											<div
												v-for="filterCountry in filterCountries"
												v-bind:key="filterCountry.id"
												class="dynvibeFiltersListCountry"
												@click="removeFromFilterCountries(filterCountry)"
											>
												<span>{{ filterCountry.value }}</span>
												<i class="icon-x"></i>
											</div>
										</div>
									</div>
								</div>
								<div class="source">
									<span class="filterTitle">Sources</span>
									<ul style="list-style: none; padding-left: 0px">
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="twitter"
													v-model="sources"
													v-bind:class="{
														active: sources.includes('twitter'),
													}"
												/>
												<label for="twitter">Twitter</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="instagram"
													v-model="sources"
													v-bind:class="{
														active: sources.includes('instagram'),
													}"
												/>
												<label for="instagram">Instagram</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="youtube"
													v-model="sources"
													v-bind:class="{
														active: sources.includes('youtube'),
													}"
												/>
												<label for="youtube">Youtube</label>
											</div>
										</li>
										<li>
											<div class="checkboxContainer">
												<input
													type="checkbox"
													value="pinterest"
													v-model="sources"
													v-bind:class="{
														active: sources.includes('pinterest'),
													}"
												/>
												<label for="pinterest">Pinterest</label>
											</div>
										</li>
									</ul>
								</div>
							</div>
							<div class="dynvibeFiltersSearch" @click="applyFilters()">Search</div>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="displayXLS">
				<ul class="nav navbar-nav dynvibeNavSearch list-group list-group-horizontal">
					<li>
						<div id="dynvibeCompareSegButton" data-toggle="popover">
							<div
								class="dynvibeButton dynvibeButtonExportSeg segmentsComparison"
								@click="segmentsDateComparisonToXls('segments')"
							>
								<img src="/img/comparesegments.svg" />
							</div>
						</div>
					</li>

					<li>
						<div id="dynvibeCompareDateButton" data-toggle="popover">
							<div class="dynvibeButton dynvibeButtonExportDate dateComparison">
								<img src="/img/comparedate.svg" />
							</div>
						</div>
					</li>
					<!--- <datepicker ref="datepicker-comparison" :showdates='false' :datefrom="dateFrom" :dateto="dateTo"
												type="comparison"
												@changedate="segmentsDateComparisonToXls('date')"></datepicker>-->
				</ul>
			</div>

			<div class="collapse navbar-collapse" id="dynvibeNavUser" v-if="displayListPanels">
				<ul class="nav navbar-nav navbar-right">
					<li>
						<div class="dynvibeUser" v-bind:class="{ active: showListPanels }" @click="showListPanels = !showListPanels">
							<div class="dynvibeUserIcon">
								<i
									v-bind:class="{
										'icon-caret-down': !showListPanels,
										'icon-caret-up': showListPanels,
									}"
								></i>
							</div>
							<div class="dynvibeUserInfo">
								<div>Welcome</div>
								<div style="font-size: 18px; color: #23056b; margin-top: -7px">
									{{ panel ? panel : "Select your panel" }}
								</div>
							</div>

							<img
								class="dynvibeUserImg img-responsive"
								:src="
									image !== ''
										? basepath + '/img/panel/panels_illustrations/' + image
										: basepath + '/img/panel/imgPanelDefault.jpg'
								"
								:alt="panel"
							/>
						</div>
						<div v-show="showListPanels" class="dynvibeUserPanels">
							<div style="background-color: #fff; padding: 15px; overflow: auto; max-height: 350px">
								<ul class="list-unstyled">
									<li v-for="(item, index) in panels" v-bind:key="index" class="dynvibeUserPanelsLink">
										<a @click="updatepanel(item._source.label)">
											<div style="text-align: right; width: 70%; margin-right: 10px">
												<div style="color: #8878af; text-transform: uppercase">{{ item._source.label }}</div>
												<br />
												<div style="font-weight: 400">see criterias</div>
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</li>

					<!-- <li v-if="segment">
						<div class="dynvibeUser" v-bind:class="{ active: showListPanels }" @click="showListPanels = !showListPanels">
							<div class="dynvibeUserIcon">
								<i
									v-bind:class="{
										'icon-caret-down': !showListPanels,
										'icon-caret-up': showListPanels,
									}"
								></i>
							</div>
							<div class="dynvibeUserInfo">
								<div style="text-transform: uppercase">
									{{ panel }}
								</div>
								<div style="font-size: 18px; color: #23056b; margin-top: -7px">
									{{ segment !== "" ? segment : "Select your segment" }}
								</div>
							</div>

							<img
								class="dynvibeUserImg img-responsive"
								:src="
									image !== ''
										? basepath + '/detect/img/panel/panels_illustrations/' + image
										: basepath + '/detect/img/panel/imgPanelDefault.jpg'
								"
								:alt="panel"
							/>
						</div>
						<div v-show="showListPanels" class="dynvibeUserPanels">
							<div style="background-color: #fff; padding: 15px; overflow: auto; max-height: 350px">
								<ul class="list-unstyled">
									<li v-for="item in allSegments" v-bind:key="item" class="dynvibeUserPanelsLink">
										<a :href="'/detect/topics?idUser=' + userId + '&segment=' + item + '&panelSegment=' + panel">
											<div style="text-align: left">
												<div style="color: #8878af; text-transform: uppercase">
													{{ item }}
												</div>
												<br />
											</div>
										</a>
									</li>
								</ul>
							</div>
							<a id="dynvibeAllPanels" :href="'/detect/subscribe?idUser=' + userId">See all panels</a>
						</div>
					</li> -->
				</ul>
			</div>
		</div>

		<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
			<template v-slot:confirm-body>{{ confirmMessage }}</template>
		</confirm>
	</nav>
</template>

<script>
import datepicker from "@/components/globalVue/datePicker.vue";
import confirm from "@/components/globalVue/Confirm.vue";

export default {
	name: "navpage",
	emits: ["datepickercreated", "changedate"],
	props: {
		stringlayout: {},
		pagename: {
			type: String,
			default: "",
		},
		data: {},
		//image: "",
		//basepath: "",
		//stringparametersget: {},
		displayDates: {
			type: Boolean,
			default: false,
		},
		displayFilters: {
			type: Boolean,
			default: false,
		},
		displayXLS: {
			type: Boolean,
			default: false,
		},
		middle: {
			type: Boolean,
			default: false,
		},
		updateParameters: {
			type: Boolean,
			default: true,
		},
		displayAllButton: {
			type: Boolean,
			default: true,
		},
		displayListPanels: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		datepicker: datepicker,
		//'daterangepicker' : dynvibeHttpVueLoader('./js/globalVue/dateRangePicker.vue'),
		confirm: confirm,
	},
	data() {
		return {
			layout: {},
			panel: "",
			segment: "",
			allSegments: [],
			image: "",
			basepath: "",
			userId: 0,
			//parametersget: {},
			dateFrom: "",
			dateTo: "",
			showListPanels: false,
			showFilters: false,
			selectedCountry: "",
			filterCountries: [],
			genders: [],
			ages: [],
			sources: [],
			panels: [],
			activeFilters: false,
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			countrieslist: [],
			countrieslistOld: [
				// old version used
				{ id: "ar", name: "Argentina" },
				{ id: "au", name: "Australia" },
				{ id: "at", name: "Austria" },
				{ id: "be", name: "Belgium" },
				{ id: "br", name: "Brasil" },
				{ id: "ca", name: "Canada" },
				{ id: "cl", name: "Chile" },
				{ id: "cn", name: "China" },
				{ id: "co", name: "Colombia" },
				{ id: "cu", name: "Cuba" },
				{ id: "cz", name: "Czech Republic" },
				{ id: "eg", name: "Egypt" },
				{ id: "fr", name: "France" },
				{ id: "de", name: "Germany" },
				{ id: "gr", name: "Greece" },
				{ id: "hu", name: "Hungaria" },
				{ id: "hk", name: "Hong-Kong" },
				{ id: "in", name: "India" },
				{ id: "id", name: "Indonesia" },
				{ id: "ie", name: "Ireland" },
				{ id: "il", name: "Israel" },
				{ id: "it", name: "Italia" },
				{ id: "jp", name: "Japan" },
				{ id: "kr", name: "Korea" },
				{ id: "mx", name: "Mexico" },
				{ id: "nl", name: "Netherlands" },
				{ id: "nz", name: "New-Zealand" },
				{ id: "no", name: "Norway" },
				{ id: "pl", name: "Poland" },
				{ id: "pt", name: "Portugal" },
				{ id: "qa", name: "Qatar" },
				{ id: "ru", name: "Russia" },
				{ id: "sa", name: "Saudi Arabia" },
				{ id: "sg", name: "Singapor" },
				{ id: "za", name: "South Africa" },
				{ id: "es", name: "Spain" },
				{ id: "se", name: "Sweden" },
				{ id: "ch", name: "Switzerland" },
				{ id: "tw", name: "Taiwan" },
				{ id: "th", name: "Thailand" },
				{ id: "tr", name: "Turkey" },
				{ id: "ua", name: "Ukraine" },
				{ id: "ae", name: "United Arab Emirates" },
				{ id: "uk", name: "UK" },
				{ id: "us", name: "USA" },
				{ id: "ve", name: "Venezuela" },
				{ id: "vn", name: "Vietnam" },
			],
		};
	},
	mounted() {
		this.panel = this.$store.getters.panel;
		this.segment = this.$store.getters.segment; // selected segment in session
		this.allSegments = []; // all the segments in the panel
		this.userId = this.$store.getters.userId;
		this.loadComponent(this.$store.getters.parameters);
		if (!this.middle && this.pagename !== "subscribe") {
			// this.getInfoPanel(); to activate when
		}
		// this.getAllPanels();
		//this.layout = JSON.parse(this.stringlayout);
		//this.parametersget = JSON.parse(this.stringparametersget);
		this.initializeLoop();
	},
	methods: {
		loadComponent(parameters) {
			this.dateFrom = parameters && parameters.date ? parameters.date.gte : null;
			this.dateTo = parameters && parameters.date ? parameters.date.lte : null;
		},
		updatepanel(panel) {
			// this.$store.dispatch("setPanel", panel);
			this.panel = panel;
		},
		getInfoPanel() {
			//let params = { panelName: this.panel };

			this.$axios
				.get(this.$backendUrl + "setPanel", {
					params: {
						panelName: this.panel,
					},
				})
				.then((response) => {
					this.image = response.data.panelDetails["_source"]["image"];
					this.allSegments = response.data.panelDetails["_source"]["segment"];
				});
		},
		getAllPanels() {
			//let params = { panelName: this.panel };
			console.log(this.backendUrl);

			this.$axios.get(this.$backendUrl + "getListPanel").then((response) => {
				this.panels = response.data.panels;
			});
		},
		collapseSidebar() {
			document.getElementById("sidebar").classList.toggle("active");
		},
		initializeLoop() {
			let params = this.$store.getters.parameters;
			this.genders = params.gender ? params.gender : [];
			this.ages = params.age ? params.age : [];
			this.sources = params.sources ? params.sources : [];
			this.filterCountries = params.country
				? params.country.map((filterCountry) => {
						return this.countrieslist.filter((country) => {
							return country.id === filterCountry;
						})[0];
				  })
				: [];
			if (this.genders.length > 0 || this.ages.length > 0 || this.sources.length > 0 || this.filterCountries.length > 0) {
				this.activeFilters = true;
			}
		},
		addCountry() {
			if (this.selectedCountry) {
				if (!this.filterCountries.includes(this.selectedCountry)) {
					this.filterCountries.push(this.selectedCountry);
				}
			}
		},
		removeFromFilterCountries(filterCountry) {
			this.filterCountries = this.filterCountries.filter((country) => country !== filterCountry);
		},
		segmentsDateComparisonToXls(type) {
			let params = { parameters: this.$store.getters.parameters };
			let url = "";
			if (type === "segments") {
				url = this.$backendUrl + "segmentsComparisonToXls";
			} else if (type === "date") {
				url = this.$backendUrl + "dateComparisonToXls";
				params.data = { datecompare: this.$store.getters.datecompare };
			}

			this.confirmLoadingModal("open");

			this.$axios.post(url, this.$Qs.stringify(params)).then(
				(response) => {
					if (type === "date") {
						this.$store.dispatch("setDateCompare", null);
					}
					this.confirmLoadingModal();
					if (response.data.isOk) {
						let files = response.data.files;
						this.downloadFiles(files);
					} else {
						this.confirmErrorModal(response.data.result);
					}
				},
				() => {
					if (type === "date") {
						this.$store.dispatch("setDateCompare", null);
					}
					this.confirmErrorModal("FAIL");
				}
			);
		},
		followingDateComparisonToXls() {
			let params = {
				parameters: this.$store.getters.parameters,
				data: { datecompare: this.$store.getters.datecompare },
			};
			this.confirmLoadingModal("open");

			this.$axios.post(this.$backendUrl + "followingDateComparaison", this.$Qs.stringify(params)).then(
				(response) => {
					this.confirmLoadingModal();
					if (response.data.isOk) {
						let file = response.data.file;
						this.downloadFiles([file]);
					} else {
						this.confirmErrorModal("FAIL : Unable to download Excel files");
					}
				},
				() => {
					this.confirmErrorModal("FAIL");
				}
			);
		},
		downloadFiles(files) {
			let temporaryDownloadLink = document.createElement("a");
			temporaryDownloadLink.style.display = "none";
			document.body.appendChild(temporaryDownloadLink);
			for (let n = 0; n < files.length; n++) {
				let download = files[n];
				temporaryDownloadLink.setAttribute("href", this.$backendUrl + "/uploads/" + download);
				temporaryDownloadLink.setAttribute("download", download);

				temporaryDownloadLink.click();
			}

			document.body.removeChild(temporaryDownloadLink);
		},
		applyFilters() {
			this.showFilters = false;
			let params = this.$store.getters.parameters;
			params.gender = this.genders;
			params.age = this.ages;
			params.country = this.filterCountries.map((country) => country.id);
			params.sources = this.sources;
			this.$store.dispatch("setParameters", params);
			if (this.genders.length > 0 || this.ages.length > 0 || this.sources.length > 0 || this.filterCountries.length > 0) {
				this.activeFilters = true;
			} else {
				this.activeFilters = false;
			}

			let expired_date = this.$moment().add(12, "hours");
			this.$store.dispatch("setExpiredFilters", expired_date.format());
		},
		setDates(start, end) {
			this.dateFrom = start;
			this.dateTo = end;
			this.$refs.datepickerclassic.setDates(start, end);
		},
	},
	watch: {
		"$store.getters.parameters": function () {
			this.loadComponent(this.$store.getters.parameters);
		},
	},
};
</script>
<style>
.bottom.in {
	display: none !important;
}

#dynvibeCompareSegButton,
#dynvibeCompareDateButton,
#dynvibeComparefollowingButton {
	cursor: pointer;
	color: #9d9d9d;
	font-size: 21px;

	background-color: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}

#dynvibeCompareSegButton:hover,
#dynvibeCompareDateButton:hover,
#dynvibeComparefollowingButton:hover {
	box-shadow: 0 0 5px #33d1cd;
}

.dynvibeButtonExportSeg,
.dynvibeButtonExportDate,
.dynvibeButtonExportFollowing {
	padding: 10px 10px !important;
	height: 50px !important;
	background: none !important;
}

.dynvibeButtonExportSeg img,
.dynvibeButtonExportDate img,
.dynvibeButtonExportFollowing img {
	width: 28px;
	height: 28px;
}

#dynvibeNavUser {
	width: 100%;
}

.navbar-btn {
	box-shadow: none;
	outline: none !important;
	border: none;
}

#sidebarCollapse {
	color: #9d9d9d;
	background-color: #fafafa;
	box-shadow: none;
}

.dynvibeUser {
	display: flex !important;
	min-width: 340px;
	cursor: pointer;
	align-items: center;
	background-color: #fafafa;
}

.dynvibeUser.active {
	background-color: #fff;
}

.dynvibeUserIcon {
	float: left;
	font-size: 6px;
	color: #9081b4;
	margin: 5px 20px;
}

.dynvibeUserInfo {
	float: left;
	color: #9d9d9d;
	font-weight: 700;
	text-transform: uppercase;
}

.dynvibeUserInfo div {
	display: block;
	float: right;
	clear: both;
}

.dynvibeUserImg {
	width: 60px;
	height: 60px;
	float: right;
	margin: 10px 20px;
	border: 5px solid #33d1cd;
	border-bottom-color: #d8d8d8;
	border-radius: 50%;
}

.dynvibeUserPanels {
	/* display: none; */
	z-index: 1;
	position: absolute;
	top: 75px;
	left: 0;
	width: 100%;
}

.dynvibeUserPanelsLink > a {
	display: block;
	padding: 5px 0px !important;
	color: #9e9e9e;
	font-size: 14px !important;
	font-weight: 700;
	background-color: #fff;
}

.dynvibeUserPanelsLink > a:hover {
	background-color: #33d1cd;
	color: #fff;
}

.dynvibeUserPanelsLink > a div {
	display: inline-block;
}

#dynvibeAllPanels {
	display: block;
	padding: 10px;
	background-color: #ccc;
	color: #5e5e5e;
	text-align: center;
	text-transform: uppercase;
	font-weight: 700;
}

#dynvibeAllPanels:hover {
	background-color: #33d1cd;
	color: #fff;
}

@media (max-width: 768px) {
	.dynvibeNavSearch {
		margin-left: 24px;
	}
}

@media (max-width: 1200px) {
	#dynvibeNavUser {
		visibility: hidden;
	}
}
</style>
<style scoped>
#dynvibeNav {
	z-index: 3;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
	min-height: 80px;
}

#dynvibeFiltersButton {
	cursor: pointer;
	color: #9d9d9d;
	font-size: 21px;
	padding: 10px 15px;
	background-color: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
	height: 50px;
}

#dynvibeFiltersButton.activeFilters {
	color: #da1111 !important;
}

#dynvibeFiltersButton:hover {
	box-shadow: 0 0 5px #33d1cd;
}

#dynvibeFiltersButton:focus {
	outline: none;
}

.container-fluid.admin {
	padding: 15px 0;
}

#dynvibeFilters input.active:before {
	content: "\e923";
	position: relative;
	top: -2px;
	font-family: "i";
	font-size: 11px;
	line-height: 20px;
}

#dynvibeFilters label {
	font-weight: 300;
	cursor: pointer;
	padding-left: 10px;
	margin-bottom: 0;
}

#dynvibeFilters .filters {
	padding: 20px;
}

#dynvibeFilters .filters select {
	color: #8f8f8f;
	background-color: #e6e6e6;
}

#dynvibeFilters .filters input {
	width: 15px;
	height: 15px;
	outline: 0 !important;
	cursor: pointer;
	background-color: #ddd;
	-webkit-appearance: none;
	margin: 2px 0px 0px 0px !important;
}

#dynvibeFilters .filterGroup {
	float: left;
	width: 49%;
}

#dynvibeFilters .filtersGroup ul {
	padding-left: 21px;
}

#dynvibeFilters .filterTitle {
	width: 100%;
	font-size: 14px;
	text-transform: uppercase;
	text-align: center;
}

#dynvibeFilters .checkboxContainer {
	display: flex;
	margin-top: 10px;
	margin-bottom: 10px;
}

#dynvibeFilters .gender .filterTitle,
#dynvibeFilters .gender input.active:before {
	color: #33d1cd;
}

#dynvibeFilters .age .filterTitle,
#dynvibeFilters .age input.active:before {
	color: #ef402e;
}

#dynvibeFilters .location > .filterTitle,
#dynvibeFilters .source > .filterTitle {
	font-size: 14px;
	text-transform: uppercase;
	color: #23056b;
}

#dynvibeFilters .location,
#dynvibeFilters .source {
	width: 100%;
	float: left;
	margin-top: 10px;
}

#dynvibeFilters .dynvibeFiltersListCountries {
	display: flex;
	flex-wrap: wrap;
	max-height: 120px;
	overflow: auto;
	margin-top: 5px;
}

#dynvibeFilters .dynvibeFiltersListCountry {
	display: flex;
	width: 100%;
	align-items: center;
	height: 20px;
	padding: 0px 4px 0px 7px;
	margin: 0px 5px 5px 0px;
	border-radius: 12px;
	font-size: 13px;
	font-weight: 700;
	cursor: pointer;
	color: #b5b5b5;
	border: 1px solid #b5b5b5;
}

#dynvibeFilters .dynvibeFiltersListCountry span {
	margin-right: 20px;
	text-transform: uppercase;
}

#dynvibeFilters .dynvibeFiltersListCountry i {
	font-size: 6px;
	padding: 4px;
	margin-left: auto;
	border-radius: 50%;
	color: #fff;
	background-color: #b6b6b6;
}

#dynvibeFilters .dynvibeFiltersSearch {
	float: left;
	width: 100%;
	margin-top: 15px;
	cursor: pointer;
	color: #5e5e5e;
	background-color: #ccc;
	padding: 10px;
	font-weight: 700;
	text-align: center;
	text-transform: uppercase;
	transition: all 0.3s;
}

#dynvibeFilters .dynvibeFiltersSearch:hover {
	color: #fff;
	background-color: #33d1cd;
}

.popovers {
	display: inline-block;
	position: relative;
}

.popover__menu {
	border-radius: 4px;
	border-top: 2px solid #49c5b6;
	background: #fff;
	list-style-type: none;
	margin: 8px 0;
	min-width: 100%;
	padding: 0.5rem 0;
	position: absolute;
	top: 100%;
	left: 0;
	box-shadow: 0 2px 3px 0 rgba(63, 63, 68, 0.2);
	transition-property: transform, opacity;
	transition-duration: 200ms;
	transition-timing-function: ease;
	transform: scale(0.9);
	transform-origin: top left;
	display: block;
	opacity: 0;
}
.popover__menu:after {
	bottom: 100%;
	left: 0.5rem;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
	border-color: rgba(255, 255, 255, 0);
	border-bottom-color: #49c5b6;
	border-width: 7px;
}

.popover__menu-item {
	white-space: nowrap;
}
.popover__menu-item button {
	border: 0;
	border-radius: 0;
	width: 100%;
	text-align: left;
}
.popover__menu-item button:hover,
.popover__menu-item button:focus {
	background-color: #f1f1f1;
}

.popover--active .popover__menu {
	transform: scale(1);
	display: block;
	opacity: 1;
}
</style>
